import { BaseSopOperation } from "./_Base";
import { TypeAssert } from "../../poly/Assert";
import { Vector3 } from "three";
import { Matrix4 } from "three";
import { CoreTransform } from "../../../core/Transform";
import { InputCloneMode } from "../../../engine/poly/InputCloneMode";
export var TransformResetMode = /* @__PURE__ */ ((TransformResetMode2) => {
  TransformResetMode2["RESET_OBJECT"] = "reset objects transform";
  TransformResetMode2["CENTER_GEO"] = "center geometries";
  TransformResetMode2["PROMOTE_GEO_TO_OBJECT"] = "center geometry and transform object";
  return TransformResetMode2;
})(TransformResetMode || {});
export const TRANSFORM_RESET_MODES = [
  "reset objects transform" /* RESET_OBJECT */,
  "center geometries" /* CENTER_GEO */,
  "center geometry and transform object" /* PROMOTE_GEO_TO_OBJECT */
];
export class TransformResetSopOperation extends BaseSopOperation {
  constructor() {
    super(...arguments);
    this._bboxCenter = new Vector3();
    this._translateMatrix = new Matrix4();
  }
  static type() {
    return "transformReset";
  }
  cook(inputCoreGroups, params) {
    const mode = TRANSFORM_RESET_MODES[params.mode];
    return this._selectMode(mode, inputCoreGroups);
  }
  _selectMode(mode, coreGroups) {
    switch (mode) {
      case "reset objects transform" /* RESET_OBJECT */: {
        return this._resetObjects(coreGroups[0]);
      }
      case "center geometries" /* CENTER_GEO */: {
        return this._centerGeos(coreGroups[0], { applyMatrixToObject: false, refCoreGroup: coreGroups[1] });
      }
      case "center geometry and transform object" /* PROMOTE_GEO_TO_OBJECT */: {
        return this._centerGeos(coreGroups[0], { applyMatrixToObject: true, refCoreGroup: coreGroups[1] });
      }
    }
    TypeAssert.unreachable(mode);
  }
  _resetObjects(coreGroup) {
    const objects = coreGroup.objects();
    for (let object of objects) {
      object.matrix.identity();
      CoreTransform.decomposeMatrix(object);
    }
    return coreGroup;
  }
  _centerGeos(coreGroup, options) {
    const objects = coreGroup.objectsWithGeo();
    let refObjects = objects;
    if (options.refCoreGroup) {
      refObjects = options.refCoreGroup.objectsWithGeo();
    }
    for (let i = 0; i < objects.length; i++) {
      const object = objects[i];
      const refObject = refObjects[i] || refObjects[refObjects.length - 1];
      const geometry = object.geometry;
      const refGeometry = refObject.geometry;
      if (geometry && refGeometry) {
        refGeometry.computeBoundingBox();
        const bbox = refGeometry.boundingBox;
        if (bbox) {
          bbox.getCenter(this._bboxCenter);
          refObject.updateMatrixWorld();
          this._bboxCenter.applyMatrix4(refObject.matrixWorld);
          if (options.applyMatrixToObject) {
            this._translateMatrix.identity();
            this._translateMatrix.makeTranslation(this._bboxCenter.x, this._bboxCenter.y, this._bboxCenter.z);
            object.matrix.multiply(this._translateMatrix);
            CoreTransform.decomposeMatrix(object);
            object.updateWorldMatrix(false, false);
          }
          this._translateMatrix.identity();
          this._translateMatrix.makeTranslation(-this._bboxCenter.x, -this._bboxCenter.y, -this._bboxCenter.z);
          geometry.applyMatrix4(this._translateMatrix);
        }
      }
    }
    return coreGroup;
  }
}
TransformResetSopOperation.DEFAULT_PARAMS = {
  mode: 0
};
TransformResetSopOperation.INPUT_CLONED_STATE = InputCloneMode.FROM_NODE;
